import { render, staticRenderFns } from "./TabFiches.vue?vue&type=template&id=3b95de66&"
import script from "./TabFiches.vue?vue&type=script&lang=js&"
export * from "./TabFiches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports